require('./base-carousel.scss');

$(window).on('slide.bs.carousel', function (e) {
    var $carousel = $(e.target);
    var $carouselSlide = $(e.relatedTarget);
    var total = $carouselSlide.siblings().length + 1;
    var index = $carouselSlide.index();

    $carousel.find('.carousel-control.right').data('link-click', {
        carousel_total: total,
        carousel_index: (total + index + 1) % total,
        carousel_prev_index: index
    });
    $carousel.find('.carousel-control.left').data('link-click', {
        carousel_total: total,
        carousel_index: (total + index - 1) % total,
        carousel_prev_index: index
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/base-carousel/base-carousel.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17